import { ValueRange } from '@/components/Filter/components/Range/types';
import { Filter, FilterTypes, HandleChange } from '@/typings/filter/types';

export const handleRange = (
  field: Filter,
  value: number[],
  currentValue: number,
  type: string,
  onChange: HandleChange
) => {
  const [min, max] =
    type === ValueRange.from
      ? [currentValue, value[1]]
      : [value[0], currentValue];

  onChange({
    id: field.id,
    type: FilterTypes.Range,
    value: min > max ? [max, min] : [min, max],
  });
};

export const getFullWidth = (min: number, max: number) => max - min;

export const getMargin = (curMin: number, min: number, width: number) =>
  (100 * (curMin - min)) / width;

export const getWidth = (
  margin: number,
  max: number,
  currMax: number,
  width: number
) => 100 - margin - ((max - currMax) / width) * 100;
